import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getDevice } from '@utils';
import Icon from '../../base_svg-icon/component';
import Link from '../../base_link/component';
import { ProductImage } from 'audamatic-ui';
import { Product } from '@utils/product';

import './styles/styles.scss';

const  BannerHero = (props) => {
  const { text1, text2, link, colourCode, backgroundImage, behindCoverImage, inFrontOfCoverImage,  products = [], productSelection = [] } = props;

  const pushGoogleTags = () => {
    props.googleTagMethods()
      .pushPromotionGoogleTag(props);
  };

  const combinedProducts = [
    ...products,
    ...productSelection,
  ];
  const booklist = () => {
    const { isMobile, isTablet } = getDevice();
    const maxItems = isMobile || isTablet ? 3 : 4;

    return combinedProducts.slice(0, maxItems).map((_product, index) => {
      const product = new Product(_product);
      return (
        <div key={index} className="cover-wrap">
          <ProductImage product={product} />
        </div>
      );
    });
  };

  const renderSmallScreenContent = () => {
    if (!!text1  || !!text2) {
      return (
        <div className="mobile-hero-body visible-xs">
          <h1 className="mobile-title">{text1}</h1>
          <div className="mobile-subtitle">{text2}</div>
          {link && (
            <Icon
              className="arrow-button"
              name="ico-arrow-circle-right"
              size={150} />
          )}
        </div>
      );
    }
  };


  const renderLargeScreenContent = () => {
    const { isTablet } = getDevice();
    return (
      <Fragment>
        <div className={`banner-hero-media ${isTablet ? 'tablet' : ''}`}>
          <div>
            {!!behindCoverImage && (
              <img className="banner-hero-media-left" src={behindCoverImage} alt={text1}/>
            )}
            {!!inFrontOfCoverImage && (
              <img className="banner-hero-media-right" src={inFrontOfCoverImage} alt={text1}/>
            )}
          </div>
        </div>
        <div className="banner-wrap-content">
          {/* Desktop versie*/}
          <div className="banner-hero-body hidden-xs">
            <h1 className="banner-hero-title">
              {!!text1 && (
                <span><span>{text1}</span></span>
              )}
            </h1>
            <div className="banner-hero-subtitle ">
              {!!text2 && (
                <span>{text2}</span>
              )}
            </div>
          </div>
          <div className="products-wrap">
            {!!combinedProducts.length && (
              <div className="booklist-images">
                {booklist()}
              </div>
            )}
          </div>
        </div>

        {link && (
          <Icon
            className="arrow-button hidden-xs"
            name="ico-arrow-circle-right"
            size={150}/>
        )}
      </Fragment>
    );
  };


  const backgroundStyle = { backgroundColor: colourCode };
  if (backgroundImage) {
    backgroundStyle.backgroundImage = `url(${backgroundImage})`;
  }
  if (link) {
    return (
      <Link to={link} className="dynamic-banner-hero" onClick={pushGoogleTags}>
        <div className={'bg-container'} style={backgroundStyle}>
          {renderLargeScreenContent()}
          {renderSmallScreenContent()}
        </div>
      </Link>
    );
  }
  return (
    <div className="dynamic-banner-hero">
      <div className={'bg-container'} style={backgroundStyle}>
        {renderLargeScreenContent()}
        {renderSmallScreenContent()}
      </div>
    </div>
  );
};


BannerHero.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  text1: PropTypes.string,
  /**
   * The subtitle which will be shown in green in the banner
   */
  text2: PropTypes.string,
  /**
   * The url the banner needs to point to
   */
  url: PropTypes.string,
  /**
   * Color code for the background
   */
  colourCode: PropTypes.string,
  /**
   * Image placed in the background
   */
  backgroundImage: PropTypes.string,
  /**
   * Image place on the left side of the banner
   */
  behindCoverImage: PropTypes.string,
  /**
   * Image place on the right side of the banner
   */
  inFrontOfCoverImage: PropTypes.string,
  /**
   * Manualy dded products
   */
  products: PropTypes.array,
  /**
   * Dynamicaly added products
   */
  productSelection: PropTypes.array,
  /**
   * An additional link that refers to another page
   */
  link: PropTypes.string,
  /**
   * Function that returns an object with
   * Google Tags methods
   */
  googleTagMethods: PropTypes.func,
};


export default BannerHero;
